export let hres6meColumns = () => {
  let indexColumns = [
    {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '10',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'seqno',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'desc_codleave',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '30',
      style: 'min-width: 150px;'
    }, {
      key: 'dtetimperiod',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 300px;',
      dataType: 'dateRange'
    }, {
      key: 'numlereq',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'statuscc',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '50',
      style: 'min-width: 200px;'
    }, {
      key: 'remarkapcc',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codapprcc',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempapcc',
      name: '',
      labelCodapp: 'HRES6MEC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6me.js